const topbar = {
    docs: 'Dokumentacja',
    help: 'Pomoc',
    subscription: 'Subskrypcja',
};
export default Object.freeze(topbar);
